import { render, staticRenderFns } from "./PersonManager.vue?vue&type=template&id=69caf075"
import script from "./PersonManager.vue?vue&type=script&lang=js"
export * from "./PersonManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports